<template>
    <div class="goodsTemplate bgc box-shadow">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="店铺模板" name="shopModel">
                <div class="modelList">
                    <div class="selfModel" @click="selfModel">
                        <div class="tipsBox">
                            <i class="el-icon-plus"></i>
                            <p class="title">自定义模板</p>
                        </div>
                    </div>
                    <div class="listItem" v-for="(item, index) in modelList" :key="index">
                        <img :src="item.img" alt="">
                        <div class="btnBox">
                            <el-button type="primary" @click="use(item.id)">应用</el-button>
                        </div>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
export default {
    name: 'goodsTemplate',
    data() {
        return {
            activeName: 'shopModel',
            modelList: [
                {img: require('@/common/images/shop/model_01.png'), id: '001'},
                {img: require('@/common/images/shop/model_02.png'), id: '002'},
                {img: require('@/common/images/shop/model_03.png'), id: '003'}
            ]
        }
    },
    mounted() {
    },
    methods: {
        handleClick() {

        },
        selfModel() {
            this.$router.push({name: 'MicroPageEdit'})
        },
        use(id) {
            this.$router.push({name: 'MicroPageEdit', query: {model: '1'}})
            sessionStorage.modelid = id
        }
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.goodsTemplate {
    min-height: 100%;
    .el-tabs{
        .el-tabs__nav{
            margin-left: 20px;
        }
        .el-tabs__content{
            .modelList{
                display: flex;
                flex-wrap: wrap;
                .selfModel{
                    width: 250px;
                    height: 440px;
                    border: 2px dashed#409EFF;
                    margin-left: 40px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                    .tipsBox{
                        .el-icon-plus{
                            font-size: 60px;
                            font-weight: 600;
                            color: #409EFF;
                        }
                        .title{
                            text-align: center;
                            font-size: 14px;
                            margin-top: 20px;
                        }
                    }
                    
                }
                .listItem{
                    width: 250px;
                    height: 440px;
                    margin-left: 40px;
                    margin-bottom: 40px;
                    position: relative;
                    img{
                        width: 250px;
                        height: 440px;
                    }
                    .btnBox{
                        top: 0;
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        background: rgba(0,0,0,.3);
                        display: none;
                        text-align: center;
                        line-height: 440px;
                        .el-button{
                            width: 96px;
                            height: 36px;
                            font-size: 14px;
                        }
                    }
                    &:hover{
                        .btnBox{
                            display: block;
                        }
                    }
                }
            }
        }
    }
}
</style>
